export const OUTPUT_FORM_ID = 'output-form';

/** The reserved onboarding-data namespace the backend persists this node's values under. */
export const OUTPUT_DATA_NAMESPACE = 'outputs';

/** Mirrors the backend's `OnboardingDataKey::validate`, so a bad key is caught before saving. */
export const OUTPUT_KEY_PATTERN = /^[A-Za-z0-9_.]+$/;
